/* eslint-disable no-multi-str */
import React from "react"
import SectionContainer from "../components/SectionContainer"
import ExpViewBuilder from "./ExpViewBuilder"
import tlcLogo from "../images/tlc_games_logo.svg"
import drexelLogo from "../images/drexellogo.jpg"
import unityLogo from "../images/unitylogo.png"
import csharpLogo from "../images/csharplogo.png"
import reactLogo from "../images/reactlogo2.png"
import vueLogo from "../images/vuelogo.png"
import nodeLogo from "../images/nodelogo.png"
import javaLogo from "../images/javalogo.png"
import mysqlLogo from "../images/mysqllogo.png"

const jobs = [
  {
    projectrole: "Development Lead",
    teamname: "Virtual Reality Media",
    totaltime: "1 Year",
    startandend: "Sep'19 - Sep'20",
    companyname: "TLC Games",
    companylogo: tlcLogo,
    description: "Created a Virtual Reality game for Oculus headsets.",
    projects: [
      {
        name: "Game: Cooking With Cannibals",
        points: [
          "Developed an immersive VR experience using Unity game engine and the VRTK library",
          "Created a development timeline, managed tasks, and led the development effort in a team of 10",
          "Managed a playtesting cycle for iterative development and feedback",
          "Built game mechanics and artificial intelligence agents in non-playable characters for the player to interact with"
        ]
      },
    ],
    relatedskills: [
      {
        name: "Unity Engine",
        icon: unityLogo,
        proficiency: "Proficient"
      },
      {
        name: "C#",
        icon: csharpLogo,
        proficiency: "Proficient"
      },
    ]
  },
  {
    projectrole: "Project Lead",
    teamname: "Software Engineering Courses",
    totaltime: "6 Months",
    startandend: "Jun'19 - Nov'19",
    companyname: "Drexel University",
    companylogo: drexelLogo,
    description: "A sequence of courses focused on collaborative fullstack \
                  development following good software engineering and design principles",
    projects: [
      {
        name: "Faculty Document Repository",
        points: [
          "Led a team of 5 to refactor an old document repository application used by faculty",
          "Analyzed the documentation to reverse engineer the requirements \
          and implementation details",
          "Developed a new fullstack application from scratch matching all of \
          the requirements and specifications. Communicated with the stakeholder \
          to ensure product quality",
          "Taught Vue to the frontend developers and Expressjs to the backend developers",
          "Created a development timeline. Managed and delegated weekly tasks",
        ]
      },
      {
        name: "Online Multiplayer Checkers Game",
        points: [
          "Led a team of 4 to develop a fullstack web application with real-time \
          online multiplayer functionality",
          "Taught React to the frontend developers and Nodejs to the backend \
          developers with a focus on writing clean, idiomatic code and using good \
          design patterns",
          "Followed a Test-Driven-Development (TDD) approach to build both the \
          frontend user interface and backend server"
        ]
      },
    ],
    relatedskills: [
      {
        name: "React",
        icon: reactLogo,
        proficiency: "Proficient"
      },
      {
        name: "Vue",
        icon: vueLogo,
        proficiency: "Proficient"
      },
      {
        name: "Nodejs",
        icon: nodeLogo,
        proficiency: "Proficient"
      },
    ]
  },
  {
    projectrole: "Developer",
    teamname: "Desktop Development Courses",
    totaltime: "3 Months",
    startandend: "Mar'19 - Aug'19",
    companyname: "Drexel University",
    companylogo: drexelLogo,
    description: "A series of courses focused on building software using Java, \
                  with emphasis on using good design principles and patterns.",
    projects: [
      {
        name: "Scheduling Application",
        points: [
          "Developed a graphical application using JavaFX that allows students \
          to automatically create college course schedules with specified time preferences",
        ]
      },
      {
        name: "Quiz Application",
        points: [
          "Developed a command line application that allows users to create new \
          quizzes, modify existing ones, and take quizzes already made",
        ]
      },
    ],
    relatedskills: [
      {
        name: "Java",
        icon: javaLogo,
        proficiency: "Proficient"
      },
    ]
  },
  {
    projectrole: "Fullstack Developer",
    teamname: "Web Development Course",
    totaltime: "3 Months",
    startandend: "Jun'18 - Aug'18",
    companyname: "Drexel University",
    companylogo: drexelLogo,
    description: "This course focused on building a fullstack application \
                  for the web, with free choice to explore frameworks and libraries.",
    projects: [
      {
        name: "Recipe Search Application",
        points: [
          "Created a fullstack application to allow the user to search \
            for recipes with different search parameters, as well as persist \
            user data such as favorites and allergies",
          "Used React to build the frontend as a Single Page Application (SPA) \
          with client-side routing",
          "Used Nodejs and Express to build the server and connected it to a \
          MySQL database to persist user data"
        ]
      },
    ],
    relatedskills: [
      {
        name: "React",
        icon: reactLogo,
        proficiency: "Proficient"
      },
      {
        name: "Nodejs",
        icon: nodeLogo,
        proficiency: "Proficient"
      },
      {
        name: "MySQL",
        icon: mysqlLogo,
        proficiency: "Proficient"
      },
    ]
  },
]

const AcademicExp = () => (
  <SectionContainer header="Academic">
    <ExpViewBuilder jobs={jobs}/>
  </SectionContainer>
)

export default AcademicExp